import { Divider, Stack, Typography } from "@mui/material";
import { GradeBox } from "./GradeBox";
import { MetrixItem } from "./MetrixItem";
import { useStateWithSearchParams } from "../../hooks";
import { useGetFeedbacksAnalyticsQuery } from "../../api";
import { CustomLoader } from "../ui/CustomLoader";
import { Order } from "../../types";
import { QUERY_SEPARATOR } from "../../constant";

type SearchParams = {
  rating?: string;
  sort?: string;
  search?: string;
  has_files?: string;
  page?: string;
};

export const AverageScores = () => {
  const { searchDict } = useStateWithSearchParams<SearchParams>({
    rating: undefined,
    sort: undefined,
    search: undefined,
    has_files: undefined,
    page: undefined,
  });

  const { rating, search, has_files, page } = searchDict;
  const [sort, order] = searchDict.sort?.split("-") || [undefined, undefined];

  const { data, isLoading } = useGetFeedbacksAnalyticsQuery({
    rating: rating?.split(QUERY_SEPARATOR).map(Number) || undefined,
    sort,
    order: order as Order,
    search,
    has_files: !!has_files || undefined,
    page: page ? Number(page) - 1 : undefined,
    per_page: 10,
  });

  if (!data || isLoading) return <CustomLoader />;

  const {
    accuracy_score,
    average_score,
    expectations_score,
    impression_score,
    business_flows_score,
    total_feedbacks,
  } = data;

  const metrix = [
    {
      rate: accuracy_score,
      title: "Analysis Accuracy",
    },
    {
      rate: expectations_score,
      title: "Meeting Expectations",
    },
    {
      rate: business_flows_score,
      title: "Business Flow Support",
    },
    {
      rate: impression_score,
      title: "Overall Impression",
    },
  ];

  return (
    <Stack gap="16px" flexDirection="row">
      <Stack gap="16px">
        <Stack gap="4px">
          <Typography
            sx={{
              fontSize: "48px",
              lineHeight: "56px",
              fontWeight: 600,
              color: "#1F2932",
            }}
          >
            {average_score}
          </Typography>
          <Typography variant="body1" color="custom.textDarkBlue">
            Average Score
          </Typography>
        </Stack>
        <Stack gap="16px" flexDirection="row" alignItems="center">
          <GradeBox grade={average_score} />
          <Typography variant="body1" color="custom.textDarkBlue">
            {total_feedbacks}
          </Typography>
        </Stack>
      </Stack>
      <Divider orientation="vertical" flexItem sx={{ flexShrink: 1 }} />
      <Stack flexGrow={1} flexWrap="wrap" flexDirection="row" gap="16px 40px">
        {metrix.map(({ rate, title }) => (
          <MetrixItem key={title} rate={rate} title={title} />
        ))}
      </Stack>
    </Stack>
  );
};
